import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
} from "@fluentui/react-components";
import { Dismiss24Regular } from "@fluentui/react-icons";
import { useStyles } from "./useStyles";

export type ConfirmationDialogProps = {
  title: string;
  content: string | JSX.Element;
  open: boolean;

  showConfirmAction?: boolean;
  confirmAction?: () => void;
  confirmActionText?: string;

  showDismissAction?: boolean;
  dismissAction?: () => void;
  dismissActionText?: string;
  favoritesDialog?: boolean;
};

export const ConfirmationDialog = ({
  title,
  content,
  open,
  showConfirmAction = true,
  confirmAction = () => {},
  confirmActionText = "Yes",
  showDismissAction = true,
  dismissAction = () => {},
  dismissActionText = "No",
  favoritesDialog,
}: ConfirmationDialogProps) => {
  const styles = useStyles();
  return (
    <Dialog modalType="alert" open={open}>
      <DialogSurface className={favoritesDialog ? styles.dialogWithoutMarginTop : styles.dialog}>
        <DialogBody>
          <DialogTitle
            action={
              <DialogTrigger action="close">
                <Button
                  appearance="subtle"
                  aria-label="close"
                  icon={<Dismiss24Regular />}
                  onClick={dismissAction}
                  tabIndex={0}
                />
              </DialogTrigger>
            }
          >
            {title}
          </DialogTitle>
          <DialogContent>{content}</DialogContent>
          <DialogActions className={styles.dialogActions}>
            {showConfirmAction && (
              <DialogTrigger disableButtonEnhancement>
                <Button
                  appearance="secondary"
                  aria-label="Yes"
                  onClick={confirmAction}
                  data-testid="confirmationDialogPrimaryBtn"
                  className={styles.dialogButton}
                  tabIndex={0}
                >
                  {confirmActionText}
                </Button>
              </DialogTrigger>
            )}
            {showDismissAction && (
              <DialogTrigger disableButtonEnhancement>
                <Button
                  appearance="primary"
                  aria-label="No"
                  onClick={dismissAction}
                  data-testid="confirmationDialogSecondaryBtn"
                  className={styles.dialogButton}
                  tabIndex={0}
                >
                  {dismissActionText}
                </Button>
              </DialogTrigger>
            )}
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
